import { Form } from 'omni-common-ui';
import React from 'react';
import styles from './style.postcss';
import PropTypes from 'prop-types';

export const TaskFilterOptions = [
  {
    label: 'Tasks in 24 hours',
    value: false,
  },
  {
    label: 'All',
    value: true,
  },
];

const TaskFilter = (props) => <Form className={styles.Filter}>
  <label>Task Filter</label>
  <Form.Select className={styles.Filter_select}
      searchable={false}
      clearable={false}
      name="taskFilter"
      options={TaskFilterOptions}
      value={props.value}
      setValue={(value) => props.handleFilterChange(value)}
      fieldOptions={{
        labelTextClassName: styles.Filters_label,
        neighborStackMode: 'horizontal',
        innerStackMode: 'vertical',
      }} />
</Form>;

TaskFilter.propTypes = {
  handleFilterChange: PropTypes.func,
  value: PropTypes.string,
};

TaskFilter.options = TaskFilterOptions;

export default TaskFilter;



// WEBPACK FOOTER //
// ./containers/UserDashboard/MyTasks/TaskFilter.jsx